module.exports = "agm-map {\r\n    height: 100%;\r\n    /* width: 100%; */\r\n    /* width:\"10%\" */\r\n  }\r\n  \r\n  a {\r\n    color: darkblue;\r\n  }"